import baseApi from './baseApi'

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        method: 'POST',
        url: '/login',
        body: data,
      }),
      transformResponse: (data) => {
        if (data.Status === '400') {
          throw new Error(`username or password doesn't exist`)
        }
        return data
      },
    }),

    forgotPassword: builder.mutation({
      query: ({ email }) => ({
        method: 'POST',
        url: '/forgot_password_test',
        body: { email_id: email },
      }),
    }),

    verifyOTP: builder.mutation({
      query: ({ email, otp }) => ({
        url: `forgot_password_test?email_id=${email}&otp_user=${otp}`,
      }),
    }),

    resetPassword: builder.mutation({
      query: ({ email, password }) => ({
        method: 'POST',
        url: 'reset_password',
        body: { email_id: email, password },
      }),
    }),

    signup: builder.mutation({
      query: (data) => ({
        method: 'POST',
        url: '/signup_corporate',
        body: data,
      }),
    }),

    logout: builder.mutation({
      query: ({ userToken }) => ({
        method: 'GET',
        url: `/logout?user_id=${userToken}`,
      }),
    }),

    getHeadests: builder.query({
      query: () => ({
        method: 'POST',
        url: 'headset_list',
      }),
      transformResponse: (data) => data.headset,
    }),
  }),
  overrideExisting: false,
})

// auto-generated based on the defined endpoints
export const {
  useLoginMutation,
  useForgotPasswordMutation,
  useVerifyOTPMutation,
  useResetPasswordMutation,
  useSignupMutation,
  useGetHeadestsQuery,
  useGetProductTypeQuery,
  useLogoutMutation,
} = authApi
